import GalleryList from  './GalleryList';
import MasonryLayout from  './MasonryLayout';

export default MasonryLayout;